import Vue from "vue";
import Vuex from "vuex";
import page from "./modules/page";
import user from "./modules/user";
import limit from "./modules/limit";
import conflict from "./modules/conflict";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    page,
    user,
    limit,
    conflict,
  },
});

export default store;
